// extracted by mini-css-extract-plugin
export default {"promo-container":"PromosPrincipales_promo-container__seLdf"};